import cn from 'classnames';
import type { NextPage } from 'next';
import { useRouter } from 'next/router';

import '@webapp/ui/lib/button/button.css';

import { ColorScheme, setHtml } from '@webapp/common/lib/ui';

import { Layout } from '@webapp/landing/src/components/layout';
import type { CmsPage } from '@webapp/landing/src/resources/api';

import '@webapp/common/assets/styles/wysiwyg.css?CSSModulesDisable';

import { Head } from '../head';

import css from './content-page.css';

const Content: FC<{
    content: CmsPage;
}> = ({ content }) => (
    <>
        <h1>{content.title}</h1>
        <div {...setHtml(content.content)} />
    </>
);

export const ContentPage: NextPage<{
    content: Array<CmsPage>;
    withMenu?: boolean;
    title?: string;
    canonical?: string;
}> = ({ content, title: ttl, withMenu = true, canonical }) => {
    const { asPath } = useRouter();
    const post = content && content[0];
    const title = (post && post.browserTitle) || ttl || 'Блог Testograf';
    const descr = (post && post.descr) || 'Полезные статьи о проведении опросов';
    const keywords =
        (post && post.keywords) ||
        'создать опрос, сервис опросов, провести опрос, опрос сотрудников, опрос клиентов, голосование онлайн';

    return (
        <>
            <Head description={descr} keywords={keywords} title={title} url={canonical || asPath} />
            <Layout contentPage mode={ColorScheme.DARK} withMenu={withMenu}>
                <div className={cn(css.contentPage, withMenu && css.withMenu)}>
                    <section className={cn('wysiwyg', css.cms)}>
                        {post && content.map((c) => <Content content={c} key={c.rewrite} />)}
                    </section>
                </div>
            </Layout>
        </>
    );
};
